import { API } from "@/constants/common";
import { apiClient } from "../client/apiClient";

export class TemplateService {
  static instance: TemplateService;

  public static QUERY_KEY = {
    BASE: "template",
    FETCH_ALL: ["template", "fetch_all"],
  };

  constructor() {
    if (TemplateService.instance) {
      return TemplateService.instance;
    }
    TemplateService.instance = this;
  }

  async getTemplateList(params: any): Promise<any> {
    const data = await apiClient.get(API.TEMPLATE.LIST, params);
    return data;
  }

  async getTemplateDetail(id: string): Promise<any> {
    const { data } = await apiClient.get(API.TEMPLATE.DETAIL(id));
    return data;
  }

  async copyTemplate(id: string): Promise<any> {
    const { data } = await apiClient.post(API.TEMPLATE.COPY(id));
    return data;
  }

  async createTemplate(params: any): Promise<any> {
    const data = await apiClient.post(API.TEMPLATE.CREATE, params);
    return data;
  }

  async updateTemplate(id: string, params: any): Promise<any> {
    const data = await apiClient.put(API.TEMPLATE.UPDATE(id), params);
    return data;
  }
}
